import * as React from 'react';
import {
    NativeAdObj,
    Status,
    DeviceType,
    Vertical,
    Subvertical,
    PageType,
    Features,
} from '../../../shared/types/ast';
import Netboard from '../netboard';

export type Props = {
    adObj: NativeAdObj;
    status: Status;
    id: string;
    className?: string;
    grid: boolean;
    vertical?: Vertical;
    subvertical?: Subvertical;
    pageType?: PageType;
    deviceType: DeviceType;
    features?: Features;
};

export const RecircNativeAd = (props: Props) => {
    const {
        adObj,
        vertical,
        subvertical,
        pageType,
        id,
        className,
        deviceType,
        grid,
    } = props;

    return (
        <div id={`${id}`} className={className}>
            <Netboard
                adObj={adObj}
                grid={grid}
                vertical={vertical}
                subvertical={subvertical}
                pageType={pageType}
                deviceType={deviceType}
            />
        </div>
    );
};
